import * as React from 'react';
import StandardLayout from './StandardLayout';
import '../../styles/SplashPage.css';

interface Props {
    children: React.ReactNode;
}

const CenteredLayout = (props: Props) => (
    <StandardLayout>
        <div className="row content align-items-center justify-content-center">
            {props.children}
        </div>
    </StandardLayout>
);

export default CenteredLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/CenteredLayout.tsx